import Vue from 'vue';
import Vuex from 'vuex';
import { changeDomPrice, changeDomSelect, changeDomTransferLimit } from '../utils/utils';
const axios = require('axios')

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    sliderValue: 0,
    volumeValue: 5,
    priceValue: 19,
    mode: false,
    settings: []
  },
  mutations: {
    INIT(state, payload) {
      state.settings = payload
    },
    CHANGE_SLIDER(state, payload) {
      state.sliderValue = payload.slider
      state.volumeValue = payload.volume
      state.priceValue = payload.price
    },
    SWITCH_CHANGE(state, payload) {
      state.mode = payload
    }
  },
  actions: {
    init({commit}) {
      axios.get('https://sirvwebsite.sirv.com/settings/pricing-widget/settings.json')
        .then((response) => {
          commit('INIT', response.data)
        })
        .catch(e => console.log(e))
    },
    switchChange({state, commit}, value) {
      changeDomPrice(value, state.priceValue)
      commit('SWITCH_CHANGE', value)
    },
    changeSlider({state, commit}, value) {
      changeDomSelect(value)
      let volume, price, transferLimit;
      switch (value) {
        case 0:
          volume = 5
          price = 19
          transferLimit = 20
        break;
        case 1:
          volume = 12
          price = 39
          transferLimit = 48
        break;
        case 2:
          volume = 20
          price = 59
          transferLimit = 80
        break;
        case 3:
          volume = 40
          price = 89
          transferLimit = 160
        break;
        case 4:
          volume = 60
          price = 119
          transferLimit = 240
        break;
        case 5:
          volume = 100
          price = 199
          transferLimit = 400
        break;
        case 6:
          volume = 200
          price = 359
          transferLimit = 800
        break;
        case 7:
          volume = 350
          price = 599
          transferLimit = 1400
        break;
        case 8:
          volume = 500
          price = 849
          transferLimit = 2000
        break;
      }

      changeDomPrice(state.mode, price)
      changeDomTransferLimit(volume, transferLimit)

      commit('CHANGE_SLIDER', {
        slider: value,
        volume: volume,
        price: price
      })
    }
  },
});

export default store;
